import BaseMapper from '../../BaseMapper';

const ExtendedEventDetailsMapper = (data, context) => {
    return data;
};

export default ExtendedEventDetailsMapper;
